import classNames from "classnames";

function Emoji1({ selected = false, onClick }) {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer group"
      onClick={onClick}
    >
      <g filter="url(#filter-1)">
        <path
          d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
          className={classNames(
            "group-hover:fill-[#ED5F5F]",
            selected ? "fill-[#ED5F5F]" : "fill-[#E2E2E2]"
          )}
        />
      </g>
      <g filter="url(#filter-2)">
        <path
          d="M28.6222 48.0208C40.0116 48.0208 49.2445 38.8336 49.2445 27.5006C49.2445 16.1677 40.0116 6.98047 28.6222 6.98047C17.2329 6.98047 8 16.1677 8 27.5006C8 38.8336 17.2329 48.0208 28.6222 48.0208Z"
          stroke="white"
          strokeWidth="5"
          strokeMiterlimit="10"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M23.1371 26.3426C24.0906 26.3426 24.8635 24.9739 24.8635 23.2856C24.8635 21.5972 24.0906 20.2285 23.1371 20.2285C22.1836 20.2285 21.4106 21.5972 21.4106 23.2856C21.4106 24.9739 22.1836 26.3426 23.1371 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M34.1073 26.3426C35.0608 26.3426 35.8338 24.9739 35.8338 23.2856C35.8338 21.5972 35.0608 20.2285 34.1073 20.2285C33.1538 20.2285 32.3809 21.5972 32.3809 23.2856C32.3809 24.9739 33.1538 26.3426 34.1073 26.3426Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M22.2739 34.9389C24.6529 29.7175 32.585 29.7243 34.964 34.9389C31.1577 31.5233 26.0667 31.5031 22.2739 34.9389Z"
        className={classNames(
          "group-hover:fill-[#1E1E1E]",
          selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
        )}
      />
      <path
        d="M26.3114 20.5676L22.4438 17.4902"
        className={classNames(
          "group-hover:stroke-[#1E1E1E]",
          selected ? "stroke-[#1E1E1E]" : "stroke-[#666666]"
        )}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M31.2529 20.5676L35.1204 17.4902"
        className={classNames(
          "group-hover:stroke-[#1E1E1E]",
          selected ? "stroke-[#1E1E1E]" : "stroke-[#666666]"
        )}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <defs>
        <filter
          id="filter-1"
          x="4"
          y="2.98047"
          width="49.2446"
          height="49.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect-1" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect-1"
            result="shape"
          />
        </filter>
        <filter
          id="filter-2"
          x="1.5"
          y="0.480469"
          width="54.2446"
          height="54.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect-1" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect-1"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Emoji1;
